//terms map for links that will appear in the billing agreement content

const TERMS_MAP = {
  paypalLink: {
    contentKey: 'paypalLink',
    path: '/',
  },
  paypalPolicy: {
    contentKey: 'paypalPolicy',
    path: 'popup/about-payment-methods',
  },
  userAgreement: {
    contentKey: 'userAgreement',
    path: 'ua/useragreement-full',
  },
};

export { TERMS_MAP };
